import EntityWithIdStore from "./EntityWithIdStore";

const TaskStore = new EntityWithIdStore();
export default TaskStore;

window.TaskStore = TaskStore


// WEBPACK FOOTER //
// ./web/js/store/TaskStore.js